import React from 'react';
import { Editor, IAllProps } from '@tinymce/tinymce-react';
import { FormControl, FormHelperText, TextFieldProps } from '@material-ui/core';
import classnames from 'classnames';
import styles from './SGSWysiwyg.module.scss';

export type SGSWysiwygProps = Pick<TextFieldProps, 'id' | 'error' | 'name' | 'label' | 'helperText'> & IAllProps;

const SGSWysiwyg: React.FC<SGSWysiwygProps> = ({ id, error, name, label, helperText, ...props }) => {
    return (
        <FormControl error={error}>
            {label && (
                <label htmlFor={id || name} className={classnames(styles.label, error && styles.label__error)}>
                    {label}
                </label>
            )}
            <div className={classnames('wysiwyg', error && styles.wysiwyg__error)}>
                <Editor {...props} apiKey={process.env.REACT_APP_API_TINYMCE} />
            </div>
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    );
};

export default SGSWysiwyg;
